<template>
    <div class="modal fade" id="termsAndConditionsModal" ref="termsAndConditionsModal" tabindex="-1"
        aria-labelledby="termsAndConditionsModal" aria-hidden="true">
        <div
            class="modal-dialog modal-dialog-centered !max-w-[95%] tablet:!max-w-[75%] laptop:!max-w-[75%] !m-auto">
            <div class="modal-content !rounded-[20px] overflow-hidden shadow-2xl">
                <div class="mobile:!p-2.5 !pb-5">
                    <div class="relative">
                        <button type="button"
                            class="absolute top-3 right-2 tablet:right-4 w-6 h-6 z-50 focus:!outline-none focus:!shadow-none"
                            data-bs-dismiss="modal" aria-label="Close" @click="closeModal">
                            <img src="../../../assets/images/modal-cross-icon.svg" alt="Cross Icon"
                                class="w-[20px] sm:min-w-[30px] h-[20px] sm:min-h-[30px] object-contain">
                        </button>
                        <div
                            class="rounded-t-[20px] overflow-hidden h-[80px] bg-customBlue-100 flex flex-col justify-center gap-1 p-3 w-full">
                            <h4 class="text-[18px] sm:text-[20px] font-semibold font-poppins m-0 text-white text-center">
                                Terms and Conditions
                            </h4>
                        </div>
                    </div>
                    <div class="font-poppins px-1.5 tablet:px-2.5 pt-2.5 pb-[15px]">
                        <div ref="scrollBox" class="max-h-[70vh] customScrollbar pr-1 overflow-y-auto">
                            <div class="terms-condition-page !bg-white px-[20px] py-[20px]"
                                v-html="termsAndConditionsResponse?.terms_and_conditions_text">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Modal } from "bootstrap";
import { mapActions, mapGetters } from "vuex";

export default {
    name: "TermsAndConditionsModal",
    data() {
        return {
            modal: null,
        };
    },
    computed: {
        ...mapGetters(["termsAndConditionsResponse"]),
    },
    
    watch: {

        termsAndConditionsResponse: function (val) {
        if (val) {
            this.openModal()
        }
        },
    },

    mounted() {

    },
    methods: {
        ...mapActions(["getTermsAndConditionsCheckout"]),
        
        openModal() {
            if (this.modal) {
                this.modal.show();
                return;
            }
            const modalEl = this.$refs.termsAndConditionsModal;
            this.modal = new Modal(modalEl, { backdrop: 'static' });
            this.modal.show();
            
            modalEl.addEventListener("hidden.bs.modal", () => {
                // Handle any cleanup if needed
            });
        },

        open() {
            this.getTermsAndConditionsCheckout({
                "language_code": "en",
                "terms_type": "protection-plan"
            });
        },

        closeModal() {
            if (this.modal) {
                this.modal.hide();
            }
        }
    },
};
</script>

<style scoped>
.terms-condition-page :deep(.custom-badge) {
    position: relative;
    padding-left: 33px;
    font-size: 12px;
}

@media (min-width: 1275px) {
    .terms-condition-page :deep(.custom-badge) {
        font-size: 14px;
        padding-left: 30px;
    }

    .terms-condition-page :deep(.custom-text) {
        font-size: 14px !important;
    }

    .terms-condition-page :deep(.mb-subheading) {
        margin-bottom: 10px;
    }

    .terms-condition-page :deep(.custom-heading) {
        font-size: 28px;
        margin-bottom: 10px;
    }

    .terms-condition-page :deep(.custom-subheading) {
        font-size: 16px !important;
    }

    .terms-condition-page :deep(.custom-card) {
        padding: 15px 10px;
    }

    .terms-condition-page :deep(.custom-badge-circle) {
        height: 30px;
        width: 30px;
        min-height: 30px;
        min-width: 30px;
        font-size: 16px;
    }

    .terms-condition-page :deep(.custom-ml) {
        margin-left: 40px;
    }

    .terms-condition-page :deep(.custom-card-header) {
        gap: 10px !important;
        padding-bottom: 10px;
    }

    .terms-condition-page :deep(.text-margin) {
        margin-bottom: 15px;
    }

    .terms-condition-page :deep(.ul-listing) {
        gap: 10px;
        padding-bottom: 15px;
    }

    .terms-condition-page :deep(.bold-text) {
        margin-bottom: 10px;
    }

    .terms-condition-page :deep(.text-mb-2) {
        margin-bottom: 10px;
    }
}

.terms-condition-page :deep(.text-mb-2) {
    margin-bottom: 8px;
}

.terms-condition-page :deep(.bold-text) {
    margin-bottom: 2px;
    font-weight: 700;
}

.terms-condition-page :deep(.ul-listing) {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding-top: 10px;
    padding-bottom: 10px;
}

.terms-condition-page :deep(.text-margin) {
    margin-bottom: 8px;
}

/* Heading */
.terms-condition-page :deep(.custom-heading) {
    font-size: 24px;
    margin-bottom: 0;
    display: none;
}

.terms-condition-page :deep(.custom-badge-circle) {
    height: 25px;
    width: 25px;
    min-height: 25px;
    min-width: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-size: 14px;
    border-radius: 50%;
    color: #ffffff;
}

/* Subheading */
.terms-condition-page :deep(.custom-subheading) {
    font-size: 14px;
}

@media (min-width: 1536px) {
    .terms-condition-page :deep(.custom-subheading) {
        font-size: 18px;
    }

    .terms-condition-page :deep(.custom-heading) {
        font-size: 30px;
    }
}

@media (min-width: 720px) {
    .terms-condition-page :deep(.custom-ml) {
        margin-left: 35px;
    }

    .terms-condition-page :deep(.custom-badge) {
        padding-left: 30px;
    }

    .terms-condition-page :deep(.custom-badge::before) {
        top: 0px !important;
        left: 0px !important;
    }
}

.terms-condition-page :deep(.custom-card-header) {
    display: flex;
    align-items: center;
    gap: 8px;
    padding-bottom: 6px;
}

.terms-condition-page :deep(.custom-card) {
    width: 100%;
    border-radius: 10px;
    margin-top: 15px;
    padding: 15px;
    background-color: rgba(229, 210, 182, 0.15);
}

/* ::before pseudo-element for badge */
.terms-condition-page :deep(.custom-badge::before) {
    content: attr(data-label);
    position: absolute;
    top: -1px;
    left: 3px;
    height: 20px;
    width: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 9999px;
    font-size: 12px;
    font-weight: 600;
    color: white;
    background-color: #2359A8;
}

/* If you want a yellow variant */
.terms-condition-page :deep(.custom-badge[data-label-type="yellow"]::before) {
    background-color: #F8B134;
}

.terms-condition-page :deep(.custom-text) {
    font-size: 12px;
    font-weight: 400;
}

.terms-condition-page :deep(.text-customgray) {
    color: #333333;
}

.terms-condition-page :deep(.pt-3 .custom-text.text-customgray) {
    text-align: justify;
}

.customScrollbar::-webkit-scrollbar {
    width: 6px;
}

.customScrollbar::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
}

.customScrollbar::-webkit-scrollbar-thumb {
    background: #2459A8;
    border-radius: 10px;
}

.customScrollbar::-webkit-scrollbar-thumb:hover {
    background: #1e4a8a;
}
</style>
